module.exports = __webpack_public_path__ + "static/media/signupcash.be8077fb.png";